// Entrata "Import Journal Entries" CSV builder (PIQ Platform).
// Format per the Entrata spec archived in piq-platform/docs/entrata.
// One JE = header fields on its first line only; every line carries
// property + account + amount. A JE may span properties as long as each
// property's debits equal its credits, so no Inter-Company flag is needed.

const HEADERS = [
  "Reference", "Type", "Inter Company", "Memo", "Property Name", "Unit",
  "Post Month", "Accounting Method", "Book Type", "Set To Reverse",
  "Reversal Post Month", "Set To Pause", "Transaction Date", "Routing Tag",
  "Account Number", "Description", "Company Department", "Custom Tag",
  "Confidential", "Debit", "Credit", "DR/CR",
];

const esc = (v) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const money = (n) => (n == null || n === "" ? "" : Number(n).toFixed(2));
const ym = (period) => String(period).slice(0, 7).replace("-", "/");   // 2026-07   -> 2026/07
const ymd = (d) => String(d).slice(0, 10).replace(/-/g, "/");          // 2026-07-07 -> 2026/07/07

// journals: [{ reference, memo, postMonth: "YYYY-MM", transactionDate: "YYYY-MM-DD",
//              lines: [{ property, account, description, debit, credit }] }]
export function buildEntrataJeCsv(journals) {
  const rows = [HEADERS.map(esc).join(",")];
  for (const je of journals) {
    je.lines.forEach((l, i) => {
      const first = i === 0;
      rows.push([
        first ? je.reference : "",
        first ? "Standard" : "",
        "",                                   // Inter Company
        first ? je.memo || "" : "",
        l.property || "",
        "",                                   // Unit
        first ? ym(je.postMonth) : "",
        first ? "Both" : "",                  // Accounting Method
        first ? "Standard" : "",              // Book Type
        "", "", "",                           // Set To Reverse / Reversal Post Month / Set To Pause
        first ? ymd(je.transactionDate) : "",
        "",                                   // Routing Tag
        l.account || "",
        l.description || "",
        "", "", "",                           // Department / Custom Tag / Confidential
        money(l.debit),
        money(l.credit),
        "",                                   // DR/CR
      ].map(esc).join(","));
    });
  }
  return rows.join("\r\n");
}

export function downloadEntrataCsv(filename, journals) {
  const csv = buildEntrataJeCsv(journals);
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
